import { Component, ElementRef, Input } from '@angular/core';
import { LayoutService } from "./service/app.layout.service";
import { ApiService } from '../services/api/api.service';

@Component({
    standalone: false,
    selector: 'app-drawer',
    templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent {
    constructor(public layoutService: LayoutService, public el: ElementRef) { }

    @Input() menu : any;

    ngOnInit() {
    }

}

